export default __webpack_public_path__ + "static/media/engagement-ring.1161c5fc.png";